import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import React from 'react'

interface FooterSocialItemInterface {
  href: string,
  iconSize: string,
  iconType: string,
  iconName: string,
  iconColor: string,
  iconClassname: string,
}

const FooterSocialItem = ({
  href,
  iconSize,
  iconType,
  iconName,
  iconColor,
  iconClassname,
}: FooterSocialItemInterface) => {
  return (
    <a href={href} target="_blank" rel="noreferrer">
      <FontAwesomeIcon
        size={iconSize}
        icon={[`${iconType}`, `${iconName}`]}
        color={`var(--${iconColor})`}
        className={iconClassname}
      />
    </a>
  )
}

export default FooterSocialItem
